import { useMemo } from "react";
import { AutocompleteArrayInput, SelectInput, useGetList } from "react-admin";
import { useFormContext } from "react-hook-form";

import { MODULE_NAMES } from "@/constants";
import { useRadiusVpnServers } from "@/modules/radiusVpnServers/api/hooks";

import { type ClientAppCopyVpnFormShape, type ClientAppRecord } from "./types";

export const ClientAppCopyVpn = () => {
  const { watch, setValue } = useFormContext<ClientAppCopyVpnFormShape>();
  const { data = [] } = useGetList<ClientAppRecord>(MODULE_NAMES.CLIENT_APPS);
  const {
    data: { radiusVpnObjectsMap } = {},
    isLoading: isRadiusVpnServersLoading,
  } = useRadiusVpnServers();

  const selectedClientApp = watch("clientApp_id");

  const radiusVpnServersChoices = useMemo(
    () =>
      (
        data.find((item) => item.id === selectedClientApp)?.vpnServers ?? []
      ).map((id: string) => ({
        id,
        name: radiusVpnObjectsMap ? radiusVpnObjectsMap[id].host : id,
      })),
    [data, selectedClientApp, radiusVpnObjectsMap],
  );

  return (
    <>
      <span>Copy VPN Servers from another Client App</span>
      <SelectInput
        source="clientApp_id"
        value={selectedClientApp}
        choices={data}
        onReset={() => setValue("copyVpnServers", [])}
        resettable
      />
      <AutocompleteArrayInput
        source="copyVpnServers"
        label="Copy VPN Servers"
        choices={radiusVpnServersChoices}
        disableCloseOnSelect
        disabled={!selectedClientApp || isRadiusVpnServersLoading}
      />
    </>
  );
};
